export default __webpack_public_path__ + "img/outdoor-spaces-96ac0a.svg";